<div class="status-header">Account Status</div>

<div
  *ngIf="activationData"
  style="margin-bottom: 20px; font-family: Roboto, Helvetica Neue, sans-serif"
>
  <div class="grid">
    <div class="col-4"><label>Account Status</label></div>
    <div class="col-8">
      <span *ngIf="activationData.isSuspended" style="color: var(--orange-500)">
        &#x25cf;&nbsp;{{ activationData.status }}
      </span>
      <span *ngIf="activationData.isInactive" style="color: #e92222">
        &#x25cf;&nbsp;{{ activationData.status }}
      </span>
      <span
        *ngIf="!activationData.isInactive && !activationData.isSuspended"
        style="color: #1b852f"
      >
        &#x25cf;&nbsp;{{ activationData.status }}
      </span>
      <span
        style="margin-left: 8px; font-weight: 400; color: var(--grey-500)"
        *ngIf="activationData.isReactivated && !activationData.isSuspended"
        >(reactivated)</span
      >
    </div>
  </div>

  <div class="grid">
    <div class="col-4"><label>Date Last Updated</label></div>
    <div class="col-8">{{ (activationData.lastActionDate | date) || '-' }}</div>
  </div>

  <div class="grid">
    <div class="col-4"><label>Last Updated By</label></div>
    <div class="col-8">{{ activationData.lastActionUser }}</div>
  </div>

  <div class="grid">
    <div class="col-4"><label>Status Reason</label></div>
    <div class="col-8">{{ activationData.statusReason }}</div>
  </div>

  <div class="grid">
    <div class="col-4"><label>Reason Category</label></div>
    <div class="col-8">{{ activationData.statusReasonCategory }}</div>
  </div>

  <div class="grid">
    <div class="col-4">
      <p-checkbox
        binary="true"
        name="preventAutomaticDeactivation"
        formControlName="preventAutomaticDeactivation"
        pTooltip="Prevent Automatic Deactivation"
        label="Prevent Deactivation"
      ></p-checkbox>
    </div>
    <div class="col-8">
      <label style="margin-bottom: 8px; float: left"
        >Allow automated deactivation after this date:</label
      >
      <p-calendar
        [showIcon]="true"
        formControlName="preventAutomaticDeactivationExpiryDate"
        name="unsetDate"
        dateFormat="dd/mm/yy"
      ></p-calendar>
    </div>
  </div>

  <div class="grid" style="margin-top: 10px">
    <!-- Account is active (or reactivated) -->
    <div *ngIf="!activationData.isInactive && !activationData.isSuspended">
      <button
        type="button"
        pButton
        label="Deactivate"
        style="width: auto"
        class="red-btn"
        (click)="deactivateAccount()"
      ></button>
      <button
        type="button"
        pButton
        label="Suspend"
        style="width: auto"
        class="ui-button orange-btn-outline"
        (click)="suspendAccount()"
      ></button>
    </div>

    <!-- Account is deactivated -->
    <div *ngIf="activationData.isInactive">
      <button
        type="button"
        pButton
        label="Reactivate"
        style="width: auto"
        class="green-btn"
        (click)="activateAccount()"
      ></button>
      <button
        type="button"
        pButton
        label="Suspend"
        style="width: auto"
        class="ui-button"
        disabled="disabled"
      ></button>
    </div>

    <!-- Account is suspended -->
    <div *ngIf="activationData.isSuspended">
      <button
        type="button"
        pButton
        label="Deactivate"
        style="width: auto"
        class="red-btn"
        (click)="deactivateAccount()"
      ></button>
      <button
        type="button"
        pButton
        label="Reactivate"
        style="width: auto"
        class="green-btn"
        (click)="activateAccount()"
      ></button>
    </div>
  </div>
</div>

<p-dialog
  *ngIf="isVmeMode"
  [header]="
    !changeActivityItem.isActivation ? 'Deactivate Organisation' : 'Reactivate Organisation'
  "
  [(visible)]="showActiveStateChangeDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '560px' }"
>
  <div style="font-family: Roboto, Helvetica Neue, sans-serif">
    <div class="grid">
      <div class="col-4"><label>Engineius User</label></div>
      <div class="col-8">{{ currentUser ? currentUser.email : '-' }}</div>
    </div>

    <div class="grid">
      <div class="col-4">
        <label><span class="required">*</span>Reason</label>
      </div>
      <div class="col-8">
        <textarea
          name="reason"
          pInputTextarea
          rows="3"
          style="width: 100%"
          maxlength="250"
          [(ngModel)]="changeActivityItem.reason"
          id="reason"
        ></textarea>
      </div>
    </div>

    <div class="grid" *ngIf="customerData && !changeActivityItem.isActivation">
      <div class="col-4">
        <label><span class="required">*</span>Deactivation Category</label>
      </div>
      <div class="col-8">
        <p-dropdown
          [options]="deactivationReasonsItems"
          [(ngModel)]="changeActivityItem.deactivationReasonId"
          placeholder="Select a deactivation reason"
          appendTo="body"
          [style]="{ width: '100%' }"
          [filter]="true"
        ></p-dropdown>
      </div>
    </div>

    <div class="dialog-actions">
      <button
        type="button"
        (click)="showActiveStateChangeDialog = false"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        class="ui-button btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        [icon]="isSubmitting ? 'fa fa-spin fa-spinner' : 'fa ui-icon-check'"
        [label]="
          isSubmitting
            ? 'Please wait...'
            : !changeActivityItem.isActivation
            ? 'Deactivate'
            : 'Reactivate'
        "
        class="ui-button green-btn btn-to-right"
        [disabled]="
          isSubmitting ||
          !changeActivityItem.reason ||
          (!changeActivityItem.isActivation && !changeActivityItem.deactivationReasonId)
        "
        [class.green-btn]="changeActivityItem.isActivation"
        [class.red-btn]="!changeActivityItem.isActivation"
        (click)="onDeactivateClicked()"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  *ngIf="isVmeMode"
  header="Suspend Organisation"
  [(visible)]="showSuspensionDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '450px', height: '260px;' }"
>
  <div class="ui-g" style="position: relative; height: 220px">
    <div class="ui-g-12">
      <div class="ui-grid-col-12">Engineius User: {{ currentUser ? currentUser.email : '-' }}</div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Reason</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea
          name="reason"
          pInputTextarea
          style="width: 100%"
          maxlength="250"
          [(ngModel)]="changeActivityItem.suspensionReasonText"
          id="suspendReason"
        ></textarea>
      </div>
    </div>

    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Suspension Category</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="suspensionReasonsItems"
          [(ngModel)]="changeActivityItem.suspensionReasonId"
          placeholder="Select a suspension reason"
        ></p-dropdown>
      </div>
    </div>

    <div style="width: 100%; height: 40px">
      <button
        type="button"
        (click)="showSuspensionDialog = false"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        class="ui-button btn-to-right"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-check"
        label="Suspend"
        class="ui-button orange-btn-outline"
        [disabled]="
          !changeActivityItem.suspensionReasonText || !changeActivityItem.suspensionReasonId
        "
        (click)="confirmChangeActivityStatus()"
      ></button>
    </div>
  </div>
</p-dialog>

<p-confirmDialog
  header="Deactivation Survey"
  key="deactivation-survey-warning"
  icon="pi pi-exclamation-triangle"
  [style]="{ width: '425px' }"
  [baseZIndex]="10000"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>
